import { View, useWindowDimensions } from 'react-native';

import { DocumentTitle } from '@/components/layout/DocumentTitle';
import { Text } from '@/components/ui';
import { isTabletUp } from '@/lib/design-system/breakpoints';

import { ChatConversationList } from './ChatConversationList.web';

export function ChatEmptyState() {
  const { width } = useWindowDimensions();
  const wide = isTabletUp(width);

  if (!wide) {
    return <ChatConversationList variant="main" />;
  }

  return (
    <View className="chat-pane items-center justify-center px-page py-page-y">
      <DocumentTitle title="Agents" />
      <Text variant="body" className="text-center text-muted">
        Choose a chat from the sidebar or start a new one.
      </Text>
    </View>
  );
}
